import { render, staticRenderFns } from "./RecentReports.vue?vue&type=template&id=61c723d2&"
import script from "./RecentReports.vue?vue&type=script&lang=js&"
export * from "./RecentReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RecentReports.vue"
export default component.exports